'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.yearsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/yearsFromNow.js
// module id = 614
// module chunks = 0